export class ErrorCode {
  static readonly DUPLICATE = 'DUPLICATE';
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/error-code.ts